import { useState } from 'preact/hooks';

// Icons
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';

export default function ProductQuantity({ min = 1, max = 999, initialQty = 1, qtyCallback = () => { }, currentSipCredits = 0, mode, className }) {
    const [qty, setQty] = useState(initialQty);

    // Determine the effective max based on mode
    const effectiveMax = mode === 'rewards' ? currentSipCredits : max;
    const canIncrement = effectiveMax > qty;
    const canDecrement = qty > min;

    return (
        // NOTE: tw-w-full will allow input to be used universally; parent container should own sizing
        <div className={`tw-flex tw-h-48 tw-w-full tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-px-12 tw-shadow-[0px_1px_4px_0px_#52525240] ${className}`}>
            <button
                className="tw-flex tw-shrink-0 tw-grow-0 tw-basis-24 tw-items-center tw-justify-center tw-border-none"
                onClick={handleDecrement}
            >
                <MinusIcon className={`tw-size-24 ${canDecrement ? 'tw-text-blue' : 'tw-text-gray-200'}`} />
            </button>
            <input
                name="quantity"
                type="number"
                inputMode="numeric"
                value={qty}
                onInput={handleChange}
                min={min}
                max={effectiveMax}
                className="tw-mb-0 tw-flex tw-size-full tw-w-full tw-shrink-0 tw-grow tw-basis-40 tw-border-0 tw-p-0 tw-text-center tw-placeholder-gray-600 tw-shadow-none focus:tw-ring-0" />
            <button
                className="tw-flex tw-shrink-0 tw-grow-0 tw-basis-24 tw-items-center tw-justify-center tw-border-none"
                onClick={handleIncrement}
            >
                <PlusIcon
                    className={`tw-size-24 
                        ${canIncrement ?
                            'tw-text-blue' :
                            'tw-text-gray-200'
                        }`
                    }
                />
            </button>
        </div>
    );

    function handleDecrement(e) {
        e.preventDefault();

        if (canDecrement) {
            const newQty = qty - 1;
            setQty(newQty);
            qtyCallback(newQty);
        }
    }

    function handleIncrement(e) {
        e.preventDefault();

        if (canIncrement) {
            const newQty = (qty || 0) + 1;
            setQty(newQty);
            qtyCallback(newQty);
        }
    }

    function handleChange(e) {
        const newQty = parseInt(e.target.value, 10);

        if (canDecrement && canIncrement) {
            setQty(newQty);
            qtyCallback(newQty);
        } else {
            const correctedNewQty = Math.min(Math.max(min, newQty), effectiveMax)
            setQty(correctedNewQty);
            qtyCallback(correctedNewQty);
        }
    }
}
